"use client";

import { useEffect, useRef } from "react";
import { useAppDispatch } from "@/store/hooks";
import { trackActivity } from "@/store/feature/activity/activityApi";
import { auth } from "@/firebase/firebase";
import { onAuthStateChanged } from "firebase/auth";

export default function GlobalActivityTracker() {
  const dispatch = useAppDispatch();
  const hasTrackedStart = useRef(false);

  useEffect(() => {
    if (typeof window === "undefined") return;

    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (!hasTrackedStart.current) {
        hasTrackedStart.current = true;
        // Track session_start after auth is initialized
        dispatch(
          trackActivity({
            source: "session_start",
            input: {
              device:
                /Mobi|Android/i.test(navigator.userAgent) ? "mobile" : "desktop",
              platform: navigator.platform,
              isAuthenticated: !!user,
            },
          })
        ).catch((err) => console.log("Activity tracking failed", err));
      }
    });

    // Track session_end on unload
    const handleUnload = () => {
      // Cannot dispatch async thunk reliably on unload, we would typically use sendBeacon
      // but the API documentation accepts a POST. We'll do our best with fetch.
      // Since it's a Redux thunk, dispatch might not complete before the page closes.
      // But we will just dispatch it anyway for demonstration.
      dispatch(
        trackActivity({
          source: "session_end",
          input: {
            durationSeconds: 0, // This would require maintaining a timer
            actionsCount: 0, // This would require maintaining an action counter
          },
        })
      );
    };

    window.addEventListener("beforeunload", handleUnload);

    return () => {
      window.removeEventListener("beforeunload", handleUnload);
      unsubscribe();
    };
  }, [dispatch]);

  return null;
}
